import React, { useEffect, useState } from "react";
import avax from "../../assets/avalanche.svg";
import { RecentTransactions, SettingsModal, TokenModal } from "../../Modals";
import swap from "../../assets/swap.svg";
import avai from "../../assets/avai.png";
import sicko from "../../assets/sicko.png";
import aleph from "../../assets/aleph.png";
import { RiListSettingsFill } from "react-icons/ri";
import { PiClockCounterClockwiseFill } from "react-icons/pi";
import AddLiquidity from "../AddLiquidity";
import nftBg from "../../assets/nft-bg.png";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import axios from "axios";
import Hopepepe from "../../assets/logo.png";
import {
  AVX_Address,
  FACTORY_Contract_Abi,
  FACTORY_Contract_Address,
  HopePepe_Contract_ABI,
  HopePepe_Contract_Address,
  HopePepePairABI,
  ROUTER_Contract_Abi,
  ROUTER_Contract_Address,
  USDC_Contract_Abi,
  USDC_Contract_Address,
  USDT_Contract_Abi,
  USDT_Contract_Address,
  WBTC_Contract_Abi,
  WBTC_Contract_Address,
} from "../../utilies/constant";
import useGetAmountOut from "../../hooks/useGetAmountOut";
import { ethers } from "ethers";
import { type } from "@testing-library/user-event/dist/type";
import useApproveTokens from "../../hooks/useApproveTokens";
import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";
import toast from "react-hot-toast";
import useTokenBalances from "../../hooks/useTokenBalances";
import ImportModal from "../../Modals/ImportModal";
import useTokenAllowance from "../../hooks/useTokenAllowance";
import { API } from "../../API/API";
import usdt from "../../assets/USDT.png";
import usdc from "../../assets/usdc.png";
import wbtc from "../../assets/WBTC.png";
import { tokensImages } from "../../Constant";
import RemoveLiquidity from "../RemoveLiquidity/RemoveLiquidity";

const Trade = () => {
  const [activeTab, setActiveTab] = useState("swap");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [isRecentModal, setIsRecentModal] = useState(false);
  const [isAddLiquidity, setIsAddLiquidity] = useState(false);
  const [isRemovedLiquidity, setIsRemovedLiquidity] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  const [removeLiquidityValue, setremoveLiquidityValue] = useState([]);
  const [selectedFromToken, setSelectedFromToken] = useState({
    name: "Select Token",
    img: null,
  });
  const [selectedToToken, setSelectedToToken] = useState({
    name: "Select Token",
    img: null,
  });
  const [fromValue, setFromValue] = useState("");
  const [contractAddresses, setContractAddresses] = useState([]);
  const [tokenType, settokenType] = useState([]);
  const weiValue = ethers.utils.parseEther(fromValue?.toString() || "0");
  const { tokenBlnc } = useGetAmountOut(
    ROUTER_Contract_Address,
    ROUTER_Contract_Abi,
    fromValue,
    "getAmountsOut",
    [weiValue?.toString() || "0", contractAddresses]
  );
  const [toValue, setToValue] = useState("");
  const [activeButton, setActiveButton] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Swap");
  const [pairData, setPairData] = useState([]);
  const [selectPair, setselectPair] = useState({});
  const [TokenBalance, setTokenBalance] = useState({
    USDT: 0,
    USDC: 0,
    HOPEPEPE: 0,
    WBTC: 0,
  });
  const [tokenAllowance, setTokenAllowance] = useState({
    USDT: 0,
    USDC: 0,
    HOPEPEPE: 0,
    WBTC: 0,
  });

  const { data, isError, isLoading } = useBalance({
    address,
  });

  const { tokenBlnc: pairValue, refetch } = useGetAmountOut(
    FACTORY_Contract_Address,
    FACTORY_Contract_Abi,
    fromValue,
    "getPair",
    [contractAddresses[0], contractAddresses[1]]
  );

  const { USDTBalance, USDCBalance, HOPEBalance, WBTCBalance } =
    useTokenBalances(fromValue, toValue, address);

  const { USDTAllowance, USDCAllowance, HOPEAllowance, WBTCAllowance } =
    useTokenAllowance(fromValue, toValue, address);

  const { tokenBlnc: getReserves } = useGetAmountOut(
    pairValue,
    HopePepePairABI,
    fromValue,
    "getReserves",
    []
  );
  const { tokenBlnc: totalLiquidity, refetch: refetchTotalLiquidity } =
    useGetAmountOut(pairValue, HopePepePairABI, 0, "totalSupply", []);

  useEffect(() => {
    if (pairValue == "0x0000000000000000000000000000000000000000") {
      setErrorMsg("No Pair Found ");
      return;
    }
    if (
      address &&
      (selectedToToken?.name == "Select Token" ||
        selectedFromToken?.name == "Select Token")
    ) {
      setErrorMsg("Select Token");
      return;
    }
    if (
      address &&
      (fromValue == "" || toValue == "") &&
      selectedFromToken?.name !== "Select Token"
    ) {
      setErrorMsg("Enter Amount");
      return;
    }
    // console.log("data?.formatted",USDTBalance)
    const checkBalance = (tokenName, balance, allowance) => {
      const allowanceValue = ethers.utils.formatUnits(
        allowance?.toString() || "0"
      );
      if (
        selectedFromToken?.name === tokenName &&
        fromValue > Number(balance)
      ) {
        setErrorMsg("Insufficient Balance");
        return true;
      }
      if (
        tokenName !== "AVAX" &&
        selectedFromToken?.name == tokenName &&
        Number(fromValue) > Number(allowanceValue)
      ) {
        setErrorMsg("Approve Token");
        return true;
      }
      return false;
    };

    const balanceOfAVAX = Number(data?.formatted || "0");
    const balanceOfUSDT = ethers.utils.formatUnits(
      USDTBalance?.toString() || "0"
    );

    const balanceOfUSDC = ethers.utils.formatUnits(
      USDCBalance?.toString() || "0"
    );

    const balanceOfHope = ethers.utils.formatUnits(
      HOPEBalance?.toString() || "0"
    );

    const balanceOfWbtc = ethers.utils.formatUnits(
      WBTCBalance?.toString() || "0"
    );

    const insufficientBalance =
      checkBalance("AVAX", balanceOfAVAX, "") ||
      checkBalance("USDT", balanceOfUSDT, USDTAllowance) ||
      checkBalance("USDC", balanceOfUSDC, USDCAllowance) ||
      checkBalance("HOPEPEPE", balanceOfHope, HOPEAllowance);
    checkBalance("WBTC", balanceOfWbtc, WBTCAllowance);

    if (!insufficientBalance) {
      setErrorMsg("Swap");
    }
    setTokenBalance({
      ...TokenBalance,
      USDT: balanceOfUSDT,
      USDC: balanceOfUSDC,
      HOPEPEPE: balanceOfHope,
      WBTC: balanceOfWbtc,
    });

    if (getReserves?.length > 0) {
      const [hoppeValueReserves, tokenValueReserves] = getReserves.map(
        (value) => ethers.utils.formatUnits(value?.toString() || "0")
      );

      const reserveMap = {
        HOPEPEPE: hoppeValueReserves,
        AVAX: tokenValueReserves,
        USDT: tokenValueReserves,
        USDC: tokenValueReserves,
        WBTC: tokenValueReserves,
      };

      const isInsufficientReserve =
        (selectedFromToken?.name === "HOPEPEPE" &&
          fromValue > Number(reserveMap[selectedFromToken?.name])) ||
        (selectedToToken &&
          (toValue > Number(reserveMap[selectedToToken?.name]) ||
            fromValue > Number(reserveMap[selectedFromToken?.name])));

      setError(isInsufficientReserve);
    }
  }, [
    getReserves,
    toValue,
    fromValue,
    selectedFromToken,
    selectedToToken,
    address,
  ]);
  useEffect(() => {
    refetch();
  }, [
    getReserves,
    toValue,
    fromValue,
    selectedFromToken,
    selectedToToken,
    address,
  ]);

  useEffect(() => {
    const AllowanceUSDT = ethers.utils.formatUnits(
      USDTAllowance?.toString() || "0"
    );

    const AllowanceUSDC = ethers.utils.formatUnits(
      USDCAllowance?.toString() || "0"
    );

    const AllowanceHope = ethers.utils.formatUnits(
      HOPEAllowance?.toString() || "0"
    );
    const AllowanceWbtc = ethers.utils.formatUnits(
      WBTCAllowance?.toString() || "0"
    );
    setTokenAllowance({
      ...tokenAllowance,
      USDT: AllowanceUSDT,
      USDC: AllowanceUSDC,
      HOPEPEPE: AllowanceHope,
      WBTC: AllowanceWbtc,
    });
  }, [fromValue, selectedFromToken, selectedToToken]);

  const handleTokenSelect = (token) => {
    const isFromActive = activeButton === "from";

    // Update selected token based on the active button
    if (isFromActive) {
      setSelectedFromToken(token);

      // Add contract address for "from"
      handleAddContractAdress("from", token);

      // Update token type
      settokenType((prevTypes) => [...prevTypes, token?.type]);

      // Set "to" token if the selected token is not HOPEPEPE
      if (token?.name !== "HOPEPEPE") {
        setSelectedToToken({
          name: "HOPEPEPE",
          img: Hopepepe,
          type: "Token",
          symbol: "HOPEPEPE",
        });

        // Add contract address for "to"
        handleAddContractAdress("to", {
          name: "HOPEPEPE",
          img: Hopepepe,
          ContractAddress: HopePepe_Contract_Address,
        });
      } else {
        // Reset "to" token if "HOPEPEPE" is selected
        setSelectedToToken({ name: "Select Token", img: null });
      }
    } else {
      // Active button is "to"
      setSelectedToToken(token);

      // Add contract address for "to"
      handleAddContractAdress("to", token);

      // Update token type
      settokenType((prevTypes) => [...prevTypes, token?.type]);

      // Set "from" token if the selected token is not HOPEPEPE
      if (token?.name !== "HOPEPEPE") {
        setSelectedFromToken({
          name: "HOPEPEPE",
          img: Hopepepe,
          type: "Token",
          symbol: "HOPEPEPE",
        });

        // Add contract address for "from"
        handleAddContractAdress("from", {
          name: "HOPEPEPE",
          img: Hopepepe,
          ContractAddress: HopePepe_Contract_Address,
        });
      } else {
        // Reset "from" token if "HOPEPEPE" is selected
        setSelectedFromToken({ name: "Select Token", img: null });
      }
    }

    // Close the modal
    setIsModalOpen(false);
  };

  useEffect(() => {
    // if (activeButton === "from") {

    if (tokenBlnc && tokenBlnc[1] !== undefined) {
      setToValue(Number(tokenBlnc[1]) / 1000000000000000000);
    }
    // }
  }, [tokenBlnc]);

  const handleAddContractAdress = (type, token) => {
    setContractAddresses((prevAddresses) => {
      // Ensure prevAddresses is always an array with two elements
      const updatedAddresses = [...(prevAddresses || [null, null])];

      if (type === "from") {
        // Update the "from" address
        updatedAddresses[0] = token?.ContractAddress;

        // Ensure "to" remains distinct and valid
        if (
          updatedAddresses[1] &&
          updatedAddresses[1] === token?.ContractAddress
        ) {
          updatedAddresses[1] = null; // Reset "to" if it conflicts
        }
      } else if (type === "to") {
        // Update the "to" address
        updatedAddresses[1] = token?.ContractAddress;

        // Ensure "from" remains distinct and valid
        if (
          updatedAddresses[0] &&
          updatedAddresses[0] === token?.ContractAddress
        ) {
          updatedAddresses[0] = null; // Reset "from" if it conflicts
        }
      }

      return updatedAddresses;
    });
  };

  const handleSwap = () => {
    setSelectedFromToken(selectedToToken);
    setSelectedToToken(selectedFromToken);
    [contractAddresses[0], contractAddresses[1]] = [
      contractAddresses[1],
      contractAddresses[0],
    ];
    setFromValue(toValue);
    setToValue(fromValue / 1000000000000000000);
  };

  const [contractAddress, contractAbi] =
    selectedFromToken?.name === "USDT"
      ? [USDT_Contract_Address, USDT_Contract_Abi]
      : selectedFromToken?.name === "USDC"
      ? [USDC_Contract_Address, USDC_Contract_Abi]
      : selectedFromToken?.name === "HOPEPEPE"
      ? [HopePepe_Contract_Address, HopePepe_Contract_ABI]
      : selectedToToken?.name === "WBTC"
      ? [WBTC_Contract_Address, WBTC_Contract_Abi]
      : [USDT_Contract_Address, USDT_Contract_Abi];

  const handleSubmit = async () => {
    try {
      let amountIn = ethers.utils.parseEther(`${fromValue}`, "ethers");
      let amountOut = ethers.utils.parseEther(`${toValue}`, "ethers");
      const unixTime = Math.floor(Date.now() / 1000);
      const unixTimePlus300 = unixTime + 300;

      if (
        selectedFromToken?.type == "Token" &&
        selectedToToken?.type == "Token"
      ) {
        setLoading(true);

        if (
          Number(fromValue) > Number(tokenAllowance[selectedFromToken.name])
        ) {
          let approveValue = ethers.utils.parseEther(
            `${Number(TokenBalance[selectedFromToken?.name])-Number(0.001)}`,
            "ethers"
          );


          const { request } = await prepareWriteContract({
            address: contractAddress,
            abi: contractAbi,
            functionName: "approve",
            args: [ROUTER_Contract_Address, Number(approveValue)],
            account: address,
          });
          const { hash } = await writeContract(request);
          const data = await waitForTransaction({
            hash,
          });
          toast.success(
            `Approve ${selectedFromToken?.name} Tokens Successful`,
            {
              duration: 5000,
            }
          );
        }

        // const { request: secondrequest } = await prepareWriteContract({
        //   address: toContractAddress,
        //   abi: toContractAbi,
        //   functionName: "approve",
        //   args: [
        //     ROUTER_Contract_Address,
        //     Number(amountOut),
        //   ],
        //   account: address,
        // });
        // const { hash: Secondhash } = await writeContract(secondrequest);
        // const data1 = await waitForTransaction({
        //   hash: Secondhash,
        // });
        // toast.success(`Approve ${selectedToToken?.name} Tokens Successful`, {
        //   duration: 5000,
        // });
        setTimeout(async () => {
          setLoading(true);
          const { request } = await prepareWriteContract({
            address: ROUTER_Contract_Address,
            abi: ROUTER_Contract_Abi,
            functionName: "swapTokensForExactTokens",
            args: [
              Number(amountOut),
              Number(amountIn),
              contractAddresses,
              address,
              unixTimePlus300,
            ],
            account: address,
          });
          const { hash } = await writeContract(request);
          const data = await waitForTransaction({
            hash,
          });
          setFromValue("");
          setToValue("");
          toast.success(`Swap Successful`, {
            duration: 5000,
          });
          setLoading(false);
        }, 3000);
      } else if (
        selectedFromToken?.type == "native" ||
        selectedToToken?.type == "native"
      ) {
        let nativeBalance = ethers.utils.formatUnits(data?.value?.toString());
        setLoading(true);
        if (
          (selectedFromToken?.type == "native"
            ? Number(fromValue)
            : Number(toValue)) < Number(nativeBalance)
        ) {
          setLoading(true);

          const { request } = await prepareWriteContract({
            address: ROUTER_Contract_Address,
            abi: ROUTER_Contract_Abi,
            functionName: "swapExactETHForTokens",
            args: [
              selectedFromToken?.type == "native"
                ? Number(amountIn)
                : Number(amountOut),
              contractAddresses,
              address,
              unixTimePlus300,
            ],
            value: amountIn.toString(),
            account: address,
          });
          const { hash } = await writeContract(request);
          const data = await waitForTransaction({
            hash,
          });
          setFromValue("");
          setToValue("");
          toast.success(`Swap Successful`, {
            duration: 5000,
          });
          setLoading(false);
        } else {
          toast.error("Insufficient Balance ");
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Some thing went Wrong");
    } finally {
      setLoading(false);

    }
  };

  const getPair = async () => {
    try {
      let res = await API.get(`/${address}`);
      // console.log("Res", res?.data);
      setPairData(res?.data);
    } catch (error) {
      console.log("Api error", error);
    }
  };
  useEffect(() => {
    if (address) {
      getPair();
    }
  }, [address]);

  return (
    <>
      <div className="min-h-screen w-full relative z-[1] bg-[#000]">
        <div className="container py-[120px] mx-auto">
          <div className="flex items-center mt-[30px] justify-center">
            <div className="flex justify-center bg-gray-100 rounded-lg p-1 w-max">
              <button
                onClick={() => {
                  setActiveTab("swap");
                  setIsAddLiquidity(false);
                }}
                className={`px-4 py-2 rounded-lg ${
                  activeTab === "swap"
                    ? "bg-white text-[green] font-semibold"
                    : "text-gray-500"
                }`}
              >
                Swap
              </button>
              <button
                onClick={() => {
                  setActiveTab("liquidity");
                  setIsAddLiquidity(false);
                }}
                className={`px-4 py-2 rounded-lg ${
                  activeTab === "liquidity"
                    ? "bg-white text-[green] font-semibold"
                    : "text-gray-500"
                }`}
              >
                Liquidity
              </button>
            </div>
          </div>
          <div className="flex justify-center mt-[40px]">
            <div className="w-11/12 lg:w-5/12">
              <div className="w-full bg-[#fff] border-[#ececfe] border-solid border-[1px] rounded-[20px] py-[20px]">
                {/* swap tab  */}
                {activeTab == "swap" ? (
                  <>
                    <div className="flex items-center justify-between border-b-[ececfe] border-b-[1px] px-[20px] pb-[20px]">
                      <div>
                        <div className="text-[#000] font-[18px] font-[500]">
                          Exchange
                        </div>
                        <div className="text-[#000] font-[18px] font-[500]">
                          Trade tokens in an instant
                        </div>
                      </div>
                      <div className="flex items-center gap-5">
                        {/* <a
                          href="javascript:void(0)"
                          className="text-[20px] text-[#000]"
                          onClick={() => setIsSettingsModalOpen(true)}
                        >
                          <RiListSettingsFill />
                        </a> */}
                        <a
                          href="javascript:void(0)"
                          className="text-[20px] text-[#000]"
                          onClick={() => setIsRecentModal(true)}
                        >
                          <PiClockCounterClockwiseFill />
                        </a>
                      </div>
                    </div>
                    <div className="px-[10px] lg:px-[20px] pt-[16px] ">
                      <p style={{ color: "red" }}>
                        {error && " Insufficient Reserves"}
                      </p>
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="text-[1em] text-[#8c8cb1] font-[500]">
                            From
                          </div>
                          <input
                            type="text"
                            className="border-none w-[250px] lg:w-auto outline-none bg-transparent text-[20px] text-[#000]"
                            placeholder="0.0"
                            value={fromValue.toLocaleString()}
                            onChange={(e) => setFromValue(e.target.value)}
                          />
                        </div>
                        <button
                          type="button"
                          className="bg-[#fff] border-[#ececfe] border-[1px] rounded-[10px] px-[15px] inline-flex items-center justify-center text-[#000] font-[18px] h-[48px] w-auto lg:min-w-[100px] gap-[12px]"
                          onClick={() => {
                            setActiveButton("from");
                            setIsModalOpen(true);
                          }}
                        >
                          <img
                            src={selectedFromToken.img}
                            className="h-[30px]"
                            alt=""
                          />
                          {selectedFromToken.name}
                        </button>
                      </div>
                      <div className="flex items-center gap-[16px] my-6">
                        <div className="bg-[#ececfe] h-[2px] w-full"></div>
                        <a href="javascript:void(0)" onClick={handleSwap}>
                          <img src={swap} className="h-[30px]" alt="" />
                        </a>
                        <div className="bg-[#ececfe] h-[2px] w-full"></div>
                      </div>
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="text-[1em] text-[#8c8cb1] font-[500]">
                            To
                          </div>
                          <input
                            type="text"
                            className="border-none w-[250px] lg:w-auto outline-none bg-transparent text-[20px] text-[#000]"
                            placeholder="0.0"
                            value={toValue.toLocaleString()}
                            onChange={(e) => setToValue(e.target.value)}
                          />
                        </div>
                        <div className="flex items-center gap-3">
                          <button
                            type="button"
                            className="bg-[#fff] border-[#ececfe] border-[1px] rounded-[10px] px-[15px] inline-flex items-center justify-center text-[#000] font-[18px] h-[48px] min-w-[100px] gap-[12px]"
                            onClick={() => {
                              setActiveButton("to");
                              setIsModalOpen(true);
                            }}
                          >
                            {selectedToToken.img && (
                              <img
                                src={selectedToToken.img}
                                className="h-[30px]"
                                alt=""
                              />
                            )}
                            {selectedToToken.name}
                          </button>
                        </div>
                      </div>
                      <button
                        type="button"
                        className={`w-full mt-[30px] h-[46px] bg-[green] rounded-[99px] ${
                          (error ||
                            Loading ||
                            (errorMsg !== "Swap" &&
                              errorMsg !== "Approve Token")) &&
                          "bg-[lightgreen]"
                        } flex items-center justify-center text-[#fff]`}
                        onClick={() =>
                          address
                            ? chain?.id == chains[0]?.id
                              ? handleSubmit()
                              : switchNetwork?.(chains[0]?.id)
                            : open()
                        }
                        disabled={
                          error ||
                          Loading ||
                          (errorMsg !== "Swap" && errorMsg !== "Approve Token")
                        }
                      >
                        {chain?.id == chains[0]?.id
                          ? address
                            ? Loading
                              ? "Loading.."
                              : errorMsg
                            : "Unlock Wallet"
                          : "Switch NetWork"}
                      </button>
                    </div>
                  </>
                ) : (
                  // liquidity tab
                  <>
                    {isRemovedLiquidity == false && isAddLiquidity == false ? (
                      <>
                        {" "}
                        <div className="flex items-start  justify-between border-b-[ececfe] border-b-[1px] px-[20px] pb-[20px]">
                          <div>
                            <div className="text-[#000] text-[18px] font-[500]">
                              Liquidity
                            </div>
                            <div className="text-[#8c8cb1] text-[14px] font-[500]">
                              Add liquidity to receive LP tokens
                            </div>
                            <button
                              type="button"
                              className="w-auto mt-4 px-[40px] h-[46px] bg-[green] rounded-[10px] flex items-center justify-center text-[#fff]"
                              onClick={() => setIsAddLiquidity(true)}
                            >
                              Add Liquidity
                            </button>
                          </div>
                          <div className="flex items-center gap-5 mt-5">
                            {/* <a
                              href="javascript:void(0)"
                              className="text-[20px] text-[#000]"
                              onClick={() => setIsSettingsModalOpen(true)}
                            >
                              <RiListSettingsFill />
                            </a> */}
                            <a
                              href="javascript:void(0)"
                              className="text-[20px] text-[#000]"
                              onClick={() => setIsRecentModal(true)}
                            >
                              <PiClockCounterClockwiseFill />
                            </a>
                          </div>
                        </div>
                        <div className="px-[20px] pt-6">
                          <div className="flex items-center justify-between">
                            <div className="text-[#8c8cb1] text-[15px] mb-2 font-[500]">
                              Your liqudity
                            </div>
                          </div>
                          <div className="p-3 mb-4 rounded-[10px] min-h-[100px] w-full bg-gray-100">
                            <div className="text-[14px] text-[#000] font-[500]">
                              {!address ? (
                                "Connect to a wallet to view your liquidity."
                              ) : (
                                <>
                                  {pairData?.swap?.map((items, index) => {
                                    return (
                                      <>
                                        <div className="flex gap-3 items-center justify-between mt-2">
                                          <div className="flex gap-3 items-center">
                                            <div className="flex gap-2 items-center">
                                              <img
                                                src={
                                                  tokensImages[
                                                    items?.TokenAName
                                                  ]
                                                }
                                                alt="TokenAName"
                                                style={{
                                                  width: "1.5rem",
                                                  height: "1.5rem",
                                                }}
                                              />
                                              <span>{items?.TokenAName}</span>
                                            </div>
                                            <span
                                              style={{
                                                fontWeight: "700",
                                                fontSize: "18px",
                                              }}
                                            >
                                              +
                                            </span>

                                            <div className="flex gap-2 items-center">
                                              <img
                                                src={
                                                  tokensImages[
                                                    items?.TokenBName
                                                  ]
                                                }
                                                alt=""
                                                style={{
                                                  width: "1.5rem",
                                                  height: "1.5rem",
                                                }}
                                              />
                                              <span>{items?.TokenBName}</span>
                                            </div>
                                          </div>
                                          <div>
                                            <button
                                              className="w-full  px-[10px] h-[30px] bg-[green] rounded-[10px] flex items-center justify-center text-[#fff]"
                                              onClick={() => {
                                                setselectPair(items);
                                                setIsImportModalOpen(true);
                                              }}
                                            >
                                              Manage Pair
                                            </button>
                                          </div>
                                        </div>
                                      </>
                                    );
                                  })}
                                </>
                              )}
                            </div>
                          </div>
                          <div className="text-[#8c8cb1] text-[15px] mb-4 font-[500]">
                            Don't see a pool you joined?{" "}
                            <a
                              href="javascript:void(0)"
                              onClick={() => setIsImportModalOpen(true)}
                            >
                              Import it.
                            </a>
                          </div>
                          <div className="text-[#8c8cb1] text-[15px] mb-4 font-[500]">
                            Or, if you staked your LP tokens in a farm, unstake
                            them to see them here.
                          </div>
                        </div>
                      </>
                    ) : isRemovedLiquidity == false &&
                      isAddLiquidity == true ? (
                      <>
                        <AddLiquidity
                          setIsAddLiquidity={setIsAddLiquidity}
                          addLiquidityValue={removeLiquidityValue}
                        />
                      </>
                    ) : (
                      isRemovedLiquidity == true &&
                      isAddLiquidity == false && (
                        <>
                          <RemoveLiquidity
                            setIsAddLiquidity={setIsAddLiquidity}
                            setIsRemovedLiquidity={setIsRemovedLiquidity}
                            removeLiquidityValue={removeLiquidityValue}
                          />
                        </>
                      )
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <TokenModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelectToken={handleTokenSelect}
        activeButton={activeButton}
        selectedFromToken={selectedFromToken}
        selectedToToken={selectedToToken}
      />
      <SettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
      />
      <RecentTransactions
        isOpen={isRecentModal}
        onClose={() => setIsRecentModal(false)}
      />
      <ImportModal
        isOpen={isImportModalOpen}
        setIsImportModalOpen={setIsImportModalOpen}
        selectPair={selectPair}
        value={true}
        setselectPair={setselectPair}
        setActiveTab={setIsAddLiquidity}
        setIsRemovedLiquidity={setIsRemovedLiquidity}
        setremoveLiquidityValue={setremoveLiquidityValue}
      />
    </>
  );
};

export default Trade;
